module.exports = __webpack_public_path__ + "img/pc7.9db3d3a7.png";